/**
 * QEVIQ Loox snippets layout enhancer
 * Forces premium multi-card grid (desktop/tablet) + swipe carousel (mobile)
 * without replacing Loox content or the native popup.
 */
(function () {
  var STYLE_ID = 'qeviq-loox-snippets-layout';
  var VISIBLE_COUNT = 3;
  var EXPANDED_COUNT = 6;

  // Hide specific Loox snippet cards from the curated preview grid.
  var HIDDEN_REVIEWERS = ['Ethan A.'];
  var SYNTHETIC_REVIEW_MARKERS = [
    '[synthetic test review]',
    'synthetic test review',
    '[synthetic review]',
    'synthetic review'
  ];

  var CSS = `
:host {
  display: block !important;
  width: 100% !important;
  max-width: 100% !important;
}
.loox-snippets-widget,
.container,
.wrapper {
  width: 100% !important;
  max-width: 100% !important;
  margin: 0 !important;
}
.container {
  --loox-snippets-u-font-size: 14px;
  --loox-snippets-u-show-border: solid;
  --loox-snippets-u-shadow: 0 0.4rem 1.4rem rgba(13, 13, 13, 0.05);
  --loox-snippets-u-border-radius: 16px;
  --loox-snippets-u-border-color: rgba(13, 13, 13, 0.08);
  --loox-snippets-u-color-background: #ffffff;
  --loox-snippets-u-color-on-background: rgba(13, 13, 13, 0.62);
  --loox-snippets-u-color-name: #0d0d0d;
  --loox-snippets-u-rating-icon-color: #b89b7a;
  --loox-snippets-u-show-rating: inline-flex;
  --loox-snippets-u-show-image: flex;
}
.grid {
  display: grid !important;
  width: 100% !important;
  max-width: 100% !important;
  gap: 1.2rem !important;
  grid-auto-flow: row !important;
  grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  overflow: visible !important;
  scroll-snap-type: none !important;
  transform: none !important;
}
@media screen and (min-width: 1100px) {
  .grid {
    grid-template-columns: repeat(3, minmax(0, 1fr)) !important;
  }
}
.quickview-button {
  display: none !important;
  width: 100% !important;
  min-width: 0 !important;
  max-width: none !important;
  margin: 0 !important;
  padding: 0 !important;
  border: 0 !important;
  background: transparent !important;
  text-align: left !important;
  cursor: pointer;
}
.quickview-button[data-qeviq-visible="true"] {
  display: block !important;
}
.element {
  display: flex !important;
  flex-direction: column !important;
  box-sizing: border-box !important;
  width: 100% !important;
  min-height: 100% !important;
  height: 100% !important;
  padding: 1.7rem 1.8rem 1.6rem !important;
  border: 1px solid rgba(13, 13, 13, 0.08) !important;
  border-radius: 16px !important;
  background: #ffffff !important;
  box-shadow: 0 0.4rem 1.4rem rgba(13, 13, 13, 0.05) !important;
}
.content {
  display: flex !important;
  flex-direction: column !important;
  gap: 0.85rem !important;
  width: 100% !important;
}
.title {
  display: flex !important;
  flex-direction: column !important;
  align-items: flex-start !important;
  gap: 0.45rem !important;
}
.name {
  color: #0d0d0d !important;
  font-size: 1.45rem !important;
  font-weight: 650 !important;
  letter-spacing: -0.01em !important;
  line-height: 1.25 !important;
}
.rating {
  display: inline-flex !important;
  gap: 0.12rem !important;
  color: #b89b7a !important;
}
.rating .loox-icon {
  width: 1.35rem !important;
  height: 1.35rem !important;
}
.text {
  display: -webkit-box !important;
  -webkit-box-orient: vertical !important;
  -webkit-line-clamp: 4 !important;
  overflow: hidden !important;
  color: rgba(13, 13, 13, 0.62) !important;
  font-size: 1.4rem !important;
  line-height: 1.55 !important;
}
.arrow,
.arrows,
[class*="arrow"] {
  display: none !important;
}
@media screen and (max-width: 989px) {
  .grid {
    grid-template-columns: repeat(2, minmax(0, 1fr)) !important;
  }
}
@media screen and (max-width: 749px) {
  .wrapper {
    overflow: hidden !important;
  }
  .grid {
    display: flex !important;
    flex-wrap: nowrap !important;
    gap: 1rem !important;
    overflow-x: auto !important;
    overflow-y: hidden !important;
    scroll-snap-type: x mandatory !important;
    -webkit-overflow-scrolling: touch !important;
    padding-bottom: 0.2rem !important;
    scrollbar-width: none;
  }
  .grid::-webkit-scrollbar {
    display: none;
  }
  .quickview-button[data-qeviq-visible="true"] {
    flex: 0 0 82% !important;
    width: 82% !important;
    max-width: 82% !important;
    scroll-snap-align: start !important;
  }
  .element {
    padding: 1.55rem 1.6rem 1.45rem !important;
  }
}
`;

  function normalizeName(value) {
    return (value || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function normalizeText(value) {
    return (value || '')
      .replace(/^["“”'\s]+|["“”'\s]+$/g, '')
      .replace(/\s+/g, ' ')
      .trim()
      .toLowerCase();
  }

  function isHiddenReviewer(name) {
    var normalized = normalizeName(name);
    return HIDDEN_REVIEWERS.some(function (hidden) {
      return normalizeName(hidden) === normalized;
    });
  }

  function isSyntheticReview(text) {
    var normalized = normalizeText(text);
    if (!normalized) return false;

    return SYNTHETIC_REVIEW_MARKERS.some(function (marker) {
      return normalized.indexOf(marker) !== -1;
    });
  }

  function isShopifyDesignMode() {
    return !!(window.Shopify && window.Shopify.designMode);
  }

  function ensureLiveLooxFeed(widget) {
    if (!widget) return;

    if (widget.hasAttribute('data-preview')) {
      widget.removeAttribute('data-preview');
    }
  }

  function watchLooxPreviewMode(widget) {
    if (!widget || widget.dataset.qcrPreviewWatch === 'true') return;
    widget.dataset.qcrPreviewWatch = 'true';

    ensureLiveLooxFeed(widget);

    if (!window.MutationObserver) return;

    var observer = new MutationObserver(function (mutations) {
      mutations.forEach(function (mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-preview') {
          ensureLiveLooxFeed(widget);
          window.setTimeout(function () {
            inject(widget);
          }, 0);
        }
      });
    });

    observer.observe(widget, { attributes: true, attributeFilter: ['data-preview'] });
  }

  function inject(widget) {
    if (!widget || !widget.shadowRoot) return false;

    ensureLiveLooxFeed(widget);

    if (!widget.shadowRoot.getElementById(STYLE_ID)) {
      var style = document.createElement('style');
      style.id = STYLE_ID;
      style.textContent = CSS;
      widget.shadowRoot.appendChild(style);
    }

    revealCards(widget);
    widget.dataset.qeviqLooxLayout = 'true';

    if (widget.shadowRoot.querySelectorAll('.quickview-button[data-qeviq-visible="true"]').length === 0) {
      scheduleRevealRetries(widget);
    }

    return true;
  }

  function scheduleRevealRetries(widget) {
    if (widget.dataset.qcrRevealRetry === 'true') return;
    widget.dataset.qcrRevealRetry = 'true';

    var tries = 0;
    var timer = window.setInterval(function () {
      tries += 1;
      ensureLiveLooxFeed(widget);
      var visible = revealCards(widget);

      if (visible > 0 || tries >= 24) {
        window.clearInterval(timer);
      }
    }, 500);
  }

  function revealCards(widget, limit) {
    var maxVisible = typeof limit === 'number' ? limit : VISIBLE_COUNT;
    var buttons = widget.shadowRoot.querySelectorAll('.quickview-button');
    var visible = 0;
    var seenTexts = {};

    buttons.forEach(function (btn) {
      var nameEl = btn.querySelector('.name');
      var textEl = btn.querySelector('.text');
      var name = nameEl ? nameEl.textContent : '';
      var text = textEl ? textEl.textContent : '';
      var textKey = normalizeText(text);
      var shouldShow = false;

      if (
        visible < maxVisible &&
        !isHiddenReviewer(name) &&
        !isSyntheticReview(text) &&
        textKey &&
        !seenTexts[textKey]
      ) {
        shouldShow = true;
        seenTexts[textKey] = true;
        visible += 1;
      }

      btn.setAttribute('data-qeviq-visible', shouldShow ? 'true' : 'false');
      btn.setAttribute('aria-hidden', shouldShow ? 'false' : 'true');
      btn.setAttribute('tabindex', shouldShow ? '0' : '-1');
    });

    return visible;
  }

  function getHomepageSection(button) {
    return button.closest('.qeviq-community-reviews--homepage[data-qcr-section]');
  }

  function setExpandedState(section, expanded) {
    var preview = section.querySelector('[data-qcr-preview]');
    var button = section.querySelector('[data-qcr-expand-reviews]');
    var label = section.querySelector('[data-qcr-expand-label]');
    var widget = section.querySelector('loox-snippets-widget');

    if (!preview || !button || !widget) return;

    preview.dataset.qcrReviewsExpanded = expanded ? 'true' : 'false';
    button.setAttribute('aria-expanded', expanded ? 'true' : 'false');

    if (label) {
      label.textContent = expanded ? 'SHOW FEWER REVIEWS' : 'SHOW MORE REVIEWS';
    }

    var arrow = section.querySelector('[data-qcr-expand-arrow]');
    if (arrow) {
      arrow.textContent = expanded ? '↑' : '→';
    }

    revealCards(widget, expanded ? EXPANDED_COUNT : VISIBLE_COUNT);

    if (expanded) {
      window.requestAnimationFrame(function () {
        preview.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      });
    }
  }

  function bindExpandControls() {
    document.querySelectorAll('[data-qcr-expand-reviews]').forEach(function (button) {
      if (button.dataset.qcrExpandBound === 'true') return;
      button.dataset.qcrExpandBound = 'true';

      button.addEventListener('click', function () {
        var section = getHomepageSection(button);
        if (!section) return;

        var preview = section.querySelector('[data-qcr-preview]');
        var expanded = preview && preview.dataset.qcrReviewsExpanded === 'true';
        setExpandedState(section, !expanded);
      });
    });
  }

  function enhanceAll() {
    document.querySelectorAll('loox-snippets-widget').forEach(function (widget) {
      watchLooxPreviewMode(widget);

      if (inject(widget)) return;

      var tries = 0;
      var timer = window.setInterval(function () {
        tries += 1;
        if (inject(widget) || tries > 40) {
          window.clearInterval(timer);
        }
      }, 150);

      if (window.MutationObserver) {
        var observer = new MutationObserver(function () {
          if (inject(widget)) observer.disconnect();
        });
        observer.observe(widget, { childList: true, subtree: true, attributes: true });
        window.setTimeout(function () {
          observer.disconnect();
        }, 8000);
      }
    });

    bindExpandControls();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', enhanceAll);
  } else {
    enhanceAll();
  }

  document.addEventListener('shopify:section:load', enhanceAll);
  window.addEventListener('load', enhanceAll);
})();
